<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/b74uQc/tc-custom/9781682300428.jpg?1728851567418" alt="This image is the cover for the book Margaret Kerr Series, The Margaret Kerr Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Margaret Kerr Series, The Margaret Kerr Series
      </h1>
      <p class="bookDescription body article font2">
        <b>Three novels about a woman’s search for truth amid the Scottish struggle for independence by an author who</b><b> “puts the history back into historical mystery” (<i>Kirkus Reviews</i>).</b><br/><br/> This volume includes three novels of mystery and intrigue in thirteenth-century Scotland from the acclaimed author of the Owen Archer series:<br/>  <br/> In <i>A Trust Betrayed</i>, Margaret Kerr searches for her missing husband after his disappearance in Edinburgh, but finds that the simmering rebellion has turned the ruined city into a web of lies and hidden motives that threaten anyone who digs too deep for the truth.<br/><br/> In <i>The Fire in the Flint</i>, Margaret and her family become the target of a series of violent raids, but what the raiders are looking for remains a mystery. As Margaret becomes more deeply involved in the rebellion, attention turns to her mother, a seer who has had visions of the “true king of Scotland.”<br/><br/> In <i>A Cruel Courtship</i>, Margaret heads to Stirling Castle on a mission to discover the fate of a young spy for the rebellion. As her travels bring her closer to the castle, however, she begins to have dreams—or are they visions?—of impending danger. The historic battle of Stirling Bridge is nearing, and the fate of Scotland rides on the outcome…<br/><br/><b>Praise for the Margaret Kerr novels:</b><br/> “With meticulous attention to historical details, from the soup Margaret eats to her characters’ plaid clothing and the language they speak (there’s a helpful glossary), the author lovingly re-creates medieval Edinburgh.”—<i>Publishers Weekly</i><br/>  <br/> “Robb’s captivating blend of history and mystery vividly evokes medieval Scotland.”—<i>Booklist</i><br/>  <br/> “A satisfying read, full of interesting detail about the life and times in Scotland in the 13th century.”—<i>Aberdeen Press &amp; Journal </i><br/><br/> Together, these stories offer a richly detailed and beautifully written account of medieval Scotland and a young woman’s awakening.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Candace Robb
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?132c6474